<template>
  <div class="content-text">
    <h2 class="title-2 text-left">4 Componente de Qualidade</h2>

    <p>
      O componente de qualidade usa os indicadores de saúde na APS para
      incentivar a adoção das Boas Práticas por gestores e profissionais de
      saúde com o objetivo de melhorar o acesso das pessoas aos serviços de
      saúde e a qualidade da prestação dos serviços oferecidos na APS para a
      população do território, buscando induzir boas práticas e aperfeiçoar os
      serviços na APS municipal.
    </p>

    <p>
      O Quadro 4 apresenta os valores por tipo de equipe e também o valor total
      por equipe.
    </p>

    <div class="container-table">
      <span style="text-transform: uppercase; font-weight: bold"
        >Quadro 4 - Valores por tipo de equipe no componente qualidade</span
      >
      <table>
        <thead>
          <tr>
            <th>QUANTIDADE</th>
            <th>CLASSIFICAÇÃO</th>
            <th>VALOR POR EQUIPE</th>
            <th>TOTAL MENSAL</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in equipes.filter(
              (el) => Number(el.quantidade || 0) > 0
            )"
            :key="index"
          >
            <td class="text-center">{{ item.quantidade }} {{ item.label }}</td>
            <td class="text-center">{{ item.classificacao }}</td>
            <td class="text-center">R$ {{ item.valorPorEquipe }}</td>
            <td class="text-center">R$ {{ item.valorTotalPorEquipe }}</td>
          </tr>
          <tr class="grey">
            <td colspan="3"><strong>Total geral</strong></td>
            <td class="text-center">
              <strong
                >R$
                {{
                  totalGeral.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                  })
                }}</strong
              >
            </td>
          </tr>
        </tbody>
      </table>
      <span class="fonte" v-html="fonte"></span>
    </div>
  </div>
</template>

<script>
import { getLabelRegra } from '../utils.js'

export default {
  props: {
    dados: {
      type: Object,
      default: () => {},
    },
    regras: {
      type: Array,
      default: () => {},
    },
    fonte: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      equipes: [],
      totalGeral: 0,
    }
  },
  mounted() {
    this.formatarEquipes()
  },
  computed: {},
  methods: {
    /**
     * Formata as equipes do componente qualidade.
     *
     * @returns {void}
     */
    formatarEquipes() {
      const equipes = this.dados?.etapa4?.equipes || []

      this.equipes = []
      this.totalGeral = 0

      equipes
        .filter((item) => item.componente !== 'CVAT')
        .forEach((item) => {
          const regra = this.regras.find((regra) => {
            return regra.label === getLabelRegra(item.equipe)
          })

          if (!regra) {
            return
          }

          const classificacao = regra.classificacao.find((classificacao) => {
            return classificacao.tipo === item.classificacaoLabel
          })

          if (!classificacao) {
            return
          }

          const quantidade = Number(item.quantidade || 0)
          const totalPorEquipe = classificacao.valor * quantidade

          this.equipes.push({
            label: regra.label,
            quantidade,
            classificacao: item.classificacaoLabel.toUpperCase(),
            valorPorEquipe: classificacao.valor.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            }),
            valorTotalPorEquipe: totalPorEquipe.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            }),
          })

          this.totalGeral += totalPorEquipe
        })
    },
  },
}
</script>

<style lang="scss"></style>
